module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Nota dell’autore")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('img', {
    attrs: {
      "alt": "img3.png",
      "src": "Images/img3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("Salvare Sean")]), _vm._v(" è il secondo romanzo della serie Storie di Seattle. Ogni libro può essere letto come una storia autonoma. Tuttavia, se desiderate leggere gli intrecci di questo gruppo di amici in ordine cronologico, cominciate con "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("Dopo Ben")]), _vm._v(", disponibile sempre presso Dreamspinner Press.")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_vm._v("Con Riley")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0